export const convertWindDir = (deg: any) => {
    const compass = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW", "N"];
    const index = Math.round((deg % 360) / 22.5);
    return compass[index];
};

export const convertTime = (unixTime: any) => {
    let dt = new Date(unixTime * 1000);
    let h = dt.getHours() > 12 ? dt.getHours() - 12 : dt.getHours();
    let m = "0" + dt.getMinutes();
    let t = h + ":" + m.substr(-2);
    return t;
};

export const getDate = () => {
    const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    const today = new Date();
    return today.toLocaleDateString("en-US", options);
};

export const getTime = () => {
    const d = new Date();
    const s = d.getSeconds();
    const m = d.getMinutes();
    const h = d.getHours();
    return h + ":" + m + ":" + s;
}
export const convertToCelsius = (fahrenheit: number) => {
    return Math.round((fahrenheit - 32) * 5 / 9);

}

export const convertToFahrenheit = (celsius: number) => {
    return Math.round((celsius * 1.8) + 32);
}

export const getWeatherIcon = (weather: string) => {
    return (weather.match(/clouds/gi) ? "wi wi-day-cloudy" : (weather.match(/clear/gi) ? "wi wi-day-sunny" : "wi wi-day-rain"));
}

export const getClock = () => {
    const currentHour = new Date().getHours();
    const hour = currentHour > 12 ? currentHour - 12 : currentHour;
    let clock = "wi wi-time-";
    for (let i = 1; i <= 12; i++) {
        if (hour === Number(i)) {
            return clock = clock + hour;
        }

    }

}
